module.exports = __webpack_public_path__ + "static/media/plus-contrast.23e57d72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/plus-contrast.svg
// module id = 267
// module chunks = 0